<template>
  <app-modal-view @close="discardUnsavedChanges">
    <template #header>
      <div class="">
        <p 
          v-t="'project.settings.project_settings'" 
          class="is-size-5 has-text-centered"
        />
      </div>
    </template>
    <template 
      #body 
    >
      <div class="lb-project-modal-content">
        <p  
          class="tabs is-centered is-marginless lb-project-settings-menu"
        >
          <ul>
            <li 
              v-if="hasAdminPermission" 
              :class="{ 'is-active': activeTab == 'INFORMATION' }"
            >
              <a
                v-t="'project.settings.information'"
                @click="activeTab = 'INFORMATION'"
              ></a>
            </li>
            <li 
              v-if="hasAdminPermission" 
              :class="{ 'is-active': activeTab == 'APPEARANCE' }"
              @click="activeTab = 'APPEARANCE'"
            >
              <a v-t="'project.settings.appearance'"></a>
            </li>
            <li
              :class="{ 'is-active': activeTab == 'ADVANCED' }"
              @click="activeTab = 'ADVANCED'"
            >
              <a v-t="'project.settings.advanced_tab_title'"></a>
            </li>
          </ul>
        </p>

        <div 
          v-if="activeTab == 'INFORMATION'" 
          key="basicConfiguration"
        >
          <project-configuration-fields
            v-model="project"
            :can-edit="canEdit"
            :is-admin="hasAdminPermission"
          />
        </div>

        <div 
          v-if="activeTab === 'APPEARANCE'" 
          class="columns is-marginless px-4 py-4"
        >
          <div class="column is-6-tablet" >
            <p
              v-t="'project.settings.project_main_image'"
              class="label"
            />
            <p class="is-size-7 is-italic has-text-grey">
                  {{ $t('project.settings.project_main_image_description') }}
              </p>
            <project-configuration-image
              :image.sync="project.image"
              :can-edit="canEdit"
            />
          </div>
          <div class="column is-6-tablet">
            <p
            v-if="project.mode != 'map'"
              v-t="'project.settings.project_background_image'"
              class="label"
            />
            <p v-if="project.mode != 'map'" class="is-size-7 is-italic has-text-grey">
                  {{ $t('project.settings.project_background_image_description') }}
              </p>
            <project-configuration-background 
            v-if="project.mode != 'map'"
              key="background"
              :background.sync="project.background"
              :background-image.sync="project.backgroundImage"
            />
          </div>
        </div>
        <project-configuration-advanced-options 
          v-if="activeTab=='ADVANCED'" 
          @update="project.configuration=$event"
        />
      </div>
    </template>
    <template #footer>
      <div class="field is-grouped lb-project-modal-footer pb-4">
        <p class="control">
          <button
            v-t="'close'"
            class="button is-black is-uppercase has-text-weight-bold"
            @click="discardUnsavedChanges"
          />
        </p>
        <p class="control">
          <button
            v-t="'Buttons.save_and_close'"
            :class="{ 'is-loading': saving }"
            :disabled="!hasChanges"
            class="button is-primary is-uppercase has-text-weight-bold"
            @click="saveChanges"
          />
        </p>
      </div>
    </template>
  </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import ProjectConfigurationFields from '@/components/ProjectConfigurationFields';
import ProjectConfigurationImage from '@/components/ProjectConfigurationImage';
import ProjectConfigurationBackground from '@/components/ProjectConfigurationBackground';
import ProjectConfigurationAdvancedOptions from '@/components/ProjectConfigurationAdvancedOptions';
import _ from 'underscore';
export default {
    components: {
        AppModalView,
        ProjectConfigurationFields,
        ProjectConfigurationImage,
        ProjectConfigurationBackground,
        ProjectConfigurationAdvancedOptions,
    },
    props: {},
    data() {
        return {
            project: this.projectSource,
            activeTab: 'INFORMATION',
            showBackground: false,
            saving: false,
            pendingChanges: false,
        };
    },
    computed: {
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
        hasEditPermission() {
            return this.$store.getters.project.accessLevel == 'edit';
        },
        canEdit() {
            return this.hasAdminPermission || this.hasEditPermission;
        },
        hasChanges() {
            return !_.isEqual(this.project, this.$store.state.project);
        },
        projectSource() {
            if (
                this.hasAdminPermission &&
                !this.$store.getters.project.folder
            ) {
                const proj = this.$store.getters.project;
                proj.folder = {};
                return proj;
            }
            return this.$store.getters.project;
        },
    },
    watch: {
        projectSource: {
            handler: function () {
                this.project = JSON.parse(JSON.stringify(this.projectSource));
            },
            immediate: true,
        },
    },
    methods: {
        saveChanges() {
            this.saving = true;
            if (!this.project.title) {
                this.saving = false;
                alert(this.$t('projectConfiguration.validation.title'));
                return;
            }
            if (_.isEmpty(this.project.folder)) {
                delete this.project.folder;
            }
            this.$store
                .dispatch('updateProject', {
                    id: this.project._id,
                    project: this.project,
                })
                .then(() => {
                    this.$emit('close');
                })
                .finally(() => {
                    this.saving = false;
                })
                .catch((e) => {
                    //show error
                    console.error(e);
                });
        },
        discardUnsavedChanges() {
            if (this.hasChanges) {
                console.log('discarding changes');
            }
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
.lb-project-modal-footer {
    margin: 0 auto;
}
.lb-project-modal-content {
    height: calc(100vh - 60vh);
}
</style>